import React from 'react';
import { DefaultLayout } from '@layouts';
import { NextSeo } from 'next-seo';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { stringify } from 'qs';
import {
  ContentBlockCard,
  Header,
  Hero,
  MediaDownloadBlock,
  Section,
} from '@components';
const Villa = ({ service }) => {
  const {
    hero,
    introduction,
    content_block,
    media_download_block,
  } = service;
  return (
    <>
      <NextSeo
        title={`Momento | ${hero?.title || 'La Villa'}`}
        description={hero?.description}
      />

      <DefaultLayout
        header={
          <Hero
            isHero
            label={hero?.label}
            title={hero?.title}
            description={hero?.description}
            hasSlider={hero?.media?.data?.length > 0}
            slides={hero?.media?.data?.map(({ attributes }) => {
              return {
                img: attributes,
              };
            })}
          />
        }
      >
        <div className="pt-16 sm:pt-0"></div>
        <Section>
          <Header
            title={introduction?.title}
            label={introduction?.label}
          >
            <p className={'md:columns-2 body mt-3'}>
              {introduction?.description}
            </p>
          </Header>
        </Section>
        <Section className={'flex justify-center'}>
          <div className="h-4"></div>
          <div className="space-y-16">
            {content_block?.map((block, index) => {
              const { media, title, description } = block;
              return (
                <ContentBlockCard
                  key={index}
                  img={
                    media?.data.length > 1
                      ? media?.data
                      : media?.data[0]?.attributes
                  }
                  index={1}
                >
                  <p className="h2 text-primary">{title}</p>

                  <p className="body max-w-[90%]">{description}</p>
                </ContentBlockCard>
              );
            })}
          </div>
        </Section>
        <MediaDownloadBlock
          header={media_download_block?.header}
          gallery={media_download_block?.gallery}
          cta={media_download_block?.cta}
        />
      </DefaultLayout>
    </>
  );
};

export default Villa;
export async function getServerSideProps({ params, locale }) {
  const path = process.env.NEXT_PUBLIC_STRAPI; // process.env.NEXT_PUBLIC_STRAPI;
  const qs = stringify(
    {
      populate: [
        'hero',
        'hero.media',
        'introduction',
        'content_block',
        'content_block.media',
        'media_download_block.cta',
        'media_download_block.cta.file',
        'media_download_block.gallery',
        'media_download_block.header',
      ],
      filters: {
        slug: { $eq: 'la-villa' },
      },

      locale: locale,
    },
    {
      encodeValuesOnly: true, // prettify URL
    },
  );
  const getProdData = await fetch(
    `${path}/accommodation-services?${qs}`,
  );

  const product = await getProdData.json();

  if (product.data[0]) {
    return {
      props: {
        service: product.data[0]?.attributes,
        ...(await serverSideTranslations(locale, ['common'])),
        path: `${path}/accommodation-services?${qs}`,
      },
    };
  }
  return {
    props: {
      service: {},
    },
  };
}
